import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuSkeleton,
} from "@volca/ui/components/ui/sidebar";

const ROWS = [0, 1, 2, 3];

export const SidebarNavSkeleton = () => (
  <SidebarGroup aria-hidden className="px-2 pt-1 pb-1">
    <SidebarMenu>
      {ROWS.map((row) => (
        <SidebarMenuItem key={row}>
          <SidebarMenuSkeleton showIcon />
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  </SidebarGroup>
);
